import { Checkbox, Classes, Dialog } from "@blueprintjs/core";
import { PlanrButton } from "modules/common/components/planr/button/Button";
import React, { useState } from "react";
import { CompletionWarningList } from "./CompletionWarningList";
import styles from "./CompletionWarningsDialog.module.scss";
import { CompletionWarning } from "./force-completion";

interface CompletionWarningsDialogProps {
    warnings: CompletionWarning[];
    orderId: string;
    /** переход к месту ошибки: окно закрывается, карточка открывается на нужной вкладке */
    onNavigate?: (link: string) => void;
    /** статус, в который переводят */
    statusName?: string;
    /** перевести в обход ошибок (режим бога); без него в окне только список */
    onForce?: () => Promise<void>;
    onClose: () => void;
}

/**
 * Проверка перед «Завершением» / «Завершено» нашла ошибки: весь список. Режиму бога — ещё настойчивое
 * предупреждение и перевод в обход ошибок, кнопка которого доступна только после явного согласия
 */
export const CompletionWarningsDialog = ({
    warnings,
    orderId,
    onNavigate,
    statusName,
    onForce,
    onClose,
}: CompletionWarningsDialogProps) => {
    const [busy, setBusy] = useState(false);
    const [agreed, setAgreed] = useState(false);

    const force = async () => {
        if (!onForce) {
            return;
        }

        setBusy(true);
        try {
            await onForce();
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog
            isOpen={true}
            onClose={onClose}
            title={
                statusName
                    ? `Перед переводом в «${statusName}» нужно исправить ошибки`
                    : "Перед завершением нужно исправить ошибки"
            }
            icon="warning-sign"
            backdropClassName="standard"
            canOutsideClickClose={!busy}
            canEscapeKeyClose={!busy}
            style={{ width: 640 }}
        >
            <div className={Classes.DIALOG_BODY}>
                <div className={styles.scroll}>
                    <CompletionWarningList
                        warnings={warnings}
                        orderId={orderId}
                        onNavigate={
                            onNavigate &&
                            ((link) => {
                                onClose();
                                onNavigate(link);
                            })
                        }
                    />
                </div>
                {onForce && (
                    <div className={styles.alert}>
                        Настоятельно рекомендуется исправить ошибки до завершения. Перевод в обход проверки запишется в
                        историю договора вместе со списком ошибок.
                        <Checkbox
                            className={styles.agree}
                            checked={agreed}
                            disabled={busy}
                            onChange={() => setAgreed(!agreed)}
                            label="Понимаю, перевести, не исправляя ошибки"
                        />
                    </div>
                )}
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    {onForce && (
                        <PlanrButton type="danger" size="small" onClick={force} disabled={busy || !agreed}>
                            Завершить принудительно
                        </PlanrButton>
                    )}
                    <PlanrButton type={onForce ? "graybtn" : "greenish"} size="small" onClick={onClose} disabled={busy}>
                        Исправить ошибки
                    </PlanrButton>
                </div>
            </div>
        </Dialog>
    );
};
